module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-06.a34c93b2.jpg";